import styled from 'styled-components';
import { spacing2x } from '../../styles/spacing.js';
import { getColorWithOpacity } from '../../utils/color.js';

var AccordionDndPlaceholder = styled.div.withConfig({
  displayName: "Placeholder__AccordionDndPlaceholder",
  componentId: "sc-1imupw3-0"
})(["&&{position:absolute;border-radius:", ";", ";}"], spacing2x, function (_ref) {
  var props = _ref.props,
    theme = _ref.theme;
  return "\n        inset-inline-start: ".concat(props.clientX, "px;\n        inset-block-start: ").concat(props.clientY, "px;\n        width: ").concat(props.clientWidth, "px;\n        height: ").concat(props.clientHeight, "px;\n        background: ").concat(getColorWithOpacity(theme.CTAColors.primary, 0.1), ";\n        border: 1px dotted ").concat(theme.CTAColors.primary, ";\n  ");
});

export { AccordionDndPlaceholder };
